import PauseIcon from '@mui/icons-material/Pause';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import Button from '@mui/material/Button';

interface PlaybackButtonProps {
  onClick: () => void;
  isPaused: boolean;
}

const PlaybackButton = ({ onClick, isPaused }: PlaybackButtonProps) => (
  <Button
    variant='contained'
    color='lightGray'
    sx={{
      textTransform: 'none',
      paddingX: 1,
      minWidth: '0px',
      paddingY: 1,
      borderRadius: '42px',
    }}
    disableElevation
    onClick={onClick}
  >
    {isPaused ? (
      <PlayArrowIcon style={{ color: '#4D4D4D' }} />
    ) : (
      <PauseIcon style={{ color: '#4D4D4D' }} />
    )}
  </Button>
);

export default PlaybackButton;
